import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { LandscapePage } from './LandscapePage';

// Renders the landscape2 static site served by the @cfa/dtt-landscape backend
// plugin at ${backend.baseUrl}/api/landscape/.
export const staticLandscapePageExtension = PageBlueprint.make({
  name: 'static-landscape',
  params: {
    path: '/static-landscape',
    loader: async () => <LandscapePage />,
  },
});
